interface PageHeaderProps {
  title: string | JSX.Element;
  subtitle?: string;
  note?: string;
}

export default function PageHeader({ title, subtitle, note }: PageHeaderProps) {
  return (
    <div className="text-white">
      {subtitle && (
        <h3 className="mb-2 text-sm tracking-wide sm:text-base sm:truncate opacity-70">
          {subtitle}
        </h3>
      )}
      {typeof title === 'string' ? (
        <h2 className="text-2xl font-bold sm:text-3xl leading-7 sm:text-4xl sm:truncate">
          {title}
        </h2>
      ) : (
        title
      )}
      {note && <p className="mt-3 text-white">{note}</p>}

      <div className="w-12 h-1 mt-6 mb-10 bg-white" />
    </div>
  );
}
